import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useSendHubspotCode } from '../../../apiHooks/mutations/integrationMutations/hubspotMutations';

const HubspotRoute = () => {
  const { isLoggedIn } = useAuthStore();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const { mutateAsync: sendHubspotCode } = useSendHubspotCode();

  useEffect(() => {
    if (codeParam && isLoggedIn) {
      sendHubspotCode(codeParam).then(() => {});
    }

    if (codeParam && !isLoggedIn) {
      localStorage.setItem('hubspotCode', codeParam);
    }

    if (localStorage.getItem('hubspotCode') && isLoggedIn) {
      sendHubspotCode(localStorage.getItem('hubspotCode') as string).then(() => {});
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/auth" />;
};

export default HubspotRoute;
